import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { Maas360State, Maas360Dispatch } from './store';

export const useMaas360Dispatch = (): Maas360Dispatch =>
  useDispatch<Maas360Dispatch>();
export const useMaas360Selector: TypedUseSelectorHook<Maas360State> =
  useSelector;
